module.exports = __webpack_public_path__ + "media/images/room_menu_icon/machines-566c4523e6a7454cddc5644ee7941ee5.png";